import React, { useEffect, useState } from 'react'

export default function Timer({ version }: { version?: string }) {
  const [endTime, setEndTime] = useState<Date | null>(null)
  const [timeDifference, setTimeDifference] = useState<number | null>(600000)

  const startTimer = () => {
    if (endTime) {
      const intervalId = setInterval(() => {
        const currentTime = new Date()
        const difference = endTime.getTime() - currentTime.getTime()
        if (difference <= 0) {
          clearInterval(intervalId)
          setTimeDifference(0)
        } else {
          setTimeDifference(difference)
        }
      }, 1000)
      return () => clearInterval(intervalId)
    }
  }

  useEffect(() => {
    const currentTime = new Date()
    const endTime = new Date(currentTime.getTime() + 10.01 * 60 * 1000)
    setEndTime(endTime)
  }, [])

  useEffect(() => {
    if (endTime) {
      const currentTime = new Date()
      const difference = endTime.getTime() - currentTime.getTime()
      if (difference > 0) {
        startTimer()
      } else {
        setTimeDifference(0)
      }
    }
  }, [endTime])

  useEffect(() => {
    if (timeDifference === 0) {
      console.log('ALl')
    }
  }, [timeDifference])

  const minutes = Math.floor((timeDifference ?? 0) / (1000 * 60))
  const seconds = Math.floor(((timeDifference ?? 0) % (1000 * 60)) / 1000)

  return version && version === 'brand' ? (
    <>
      <div className="rounded-2xl f!ilter-none  max-w-full mx-2 dark:text-white text-black sticky z-20 top-0 overflow-hidden flex items-center justify-between mt-6 px-4 py-3.5">
        <div className="text-logo font-semibold">Personal offer expires in</div>
        <div className=" text-[20px] leading-[1]">
          <span className="text-[20px]  font-semibold h-6">
            {minutes < 10 ? '0' : ''}
            {minutes}
          </span>
          <span className="text-[20px] leading-[1] h-6">:</span>
          <span className="text-[20px] leading-[1] font-semibold h-6 ">
            {seconds < 10 ? '0' : ''}
            {seconds}
          </span>
        </div>
        <img
          className="absolute h-full w-full object-cover z-[-1] top-0 left-0"
          src="/img/bg-timer-new.png"
          alt="Timer"
        />
      </div>
    </>
  ) : version && version === 'alternative' ? (
    <>
      <div className="rounded-2xl filter-none  max-w-full  dark:text-white text-black relative top-0 overflow-hidden flex items-center justify-between mt-4 pr-3 pl-6 py-3">
        <div className="text-[20px] font-semibold">Personal offer expires in</div>
        <div className=" text-[18px] leading-[1] flex gap-2 items-center">
          <span className="text-[18px] flex items-center justify-center font-semibold h-10 w-12 min-w-12 rounded-[12px] border border-[#FFFFFF3D] bg-[#FFFFFF14]">
            {minutes < 10 ? '0' : ''}
            {minutes}
          </span>
          <span className="text-[18px] leading-[1] h-6">:</span>
          <span className="text-[18px] flex items-center justify-center font-semibold h-10 w-12 min-w-12 rounded-[12px] border border-[#FFFFFF3D] bg-[#FFFFFF14]">
            {seconds < 10 ? '0' : ''}
            {seconds}
          </span>
        </div>
        <img
          className="absolute h-full w-full object-cover z-[-1] top-0 left-0"
          src="/img/bg-timer-new2.svg"
          alt="Timer"
        />
      </div>
    </>
  ) : (
    <>
      <div className="rounded-[15px] text-white timer sticky z-10 top-0 overflow-hidden flex items-center justify-between mt-8 p-2 pl-5">
        <div className="text-[16px] font-bold">Personal offer expires in</div>
        <div className="flex gap-2 text-[24px]">
          <div className="p-1.5 leading-[1] font-bold min-w-[42px] h-[46px] flex justify-center items-center rounded-[10px] border border-[rgba(255,255,255,0.6)]">
            {minutes < 10 ? '0' : ''}
            {minutes}
          </div>
          <span className="text-[rgba(255,255,255,0.6)]">:</span>
          <div className="p-1.5 leading-[1] font-bold min-w-[42px] h-[46px] flex justify-center items-center rounded-[10px] border border-[rgba(255,255,255,0.6)]">
            {seconds < 10 ? '0' : ''}
            {seconds}
          </div>
        </div>
        <img
          className="absolute h-full w-full object-cover z-[-1] top-0 left-0"
          src="/img/bg-timer.png"
          alt="Timer"
        />
      </div>
    </>
  )
}
